import { v4 as uuidv4 } from 'uuid';
import logo1 from '../../assets/img/brand/b1.png';
import logo10 from '../../assets/img/brand/b10.png';
import logo2 from '../../assets/img/brand/b2.png';
import logo3 from '../../assets/img/brand/b3.png';
import logo4 from '../../assets/img/brand/b4.png';
import logo5 from '../../assets/img/brand/b5.png';
import logo6 from '../../assets/img/brand/b6.png';
import logo7 from '../../assets/img/brand/b7.png';
import logo8 from '../../assets/img/brand/b8.png';
import logo9 from '../../assets/img/brand/b9.png';

const sponsorData = [
    {
        id: uuidv4(),
        sponsorLogo: logo1,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo2,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo3,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo4,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo5,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo6,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo7,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo8,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo9,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo10,
    },
];

export default sponsorData;
